import { createReducer, on } from '@ngrx/store';
import { Lot, MarketType } from 'src/app/components/bids-and-offers/lots.model';
import {
  changeTableMarket,
  fetchData,
  newTableData,
  removeRow,
} from './table-data.actions';
import { Negotiation } from 'src/app/components/negotiations/negotiations.model';

export interface TableDataState {
  lots: Lot[];
  negotiations: Negotiation[];
  selectedMarket: MarketType | null;
}

export const initialTableDataState: TableDataState = {
  lots: [],
  negotiations: [],
  selectedMarket: null,
};

export const tableDataReducer = createReducer(
  initialTableDataState,
  on(fetchData, (state) => ({ ...state })),
  on(newTableData, (state, { newLots, market }) => {
    // checks if current table market select market equals the new incoming lot market type and adds it to the lots array
    if (state.selectedMarket === market) {
      return {
        ...state,
        lots: [...newLots],
        selectedMarket: state.selectedMarket,
      };
    } else {
      return {
        ...state,
        lots: [...state.lots],
        selectedMarket: state.selectedMarket,
      };
    }
  }),
  on(removeRow, (state, { lotId }) => ({
    ...state,
    lots: state.lots.filter((lot) => lot._id !== lotId),
  })),
  on(changeTableMarket, (state, { marketType }) => ({
    lots: [...state.lots],
    negotiations: [...state.negotiations],
    selectedMarket: marketType,
  }))
);
